import InitApp from './lib/InitApp';
import "./style/global.less";

const appKey = '.app';

try{
  const appContainers = document.querySelectorAll(appKey);

  for(let opt of appContainers.values()) {
    InitApp(opt);
  }
}catch(e){
//  message(e, 3);
  console.info(e);
}



// WEBPACK FOOTER //
// ./src/index.js